
const i18n = {
	ar: {
		dir: "rtl",
		"left": "right",
		"right": "left",
		"Don't have an account? get one in few minutes": "لا تملك حساب؟ يمكنك إنشاء حساب جديد في دقائق",
		"Get access to your orders, favorites and recommendations": "لتصل إلي طلباتك وقائمتك المفضلة وتوصياتك للمنتجات التي تهتم بها",
		"First Name": "الإسم الأول",
		"Last Name": "الإسم الأخير",
		"Password": "كلمة المرور",
		"Email": "البريد الإلكتروني",
		"Mobile": "الهاتف الجوال",
		"Register": "تسجيل حساب جديد",
		"Do you have an account?": "هل أنت عضو بالفعل؟",
		"Login": "تسجيل الدخول",
		"Did you forget your password? Type your email to change it": "هل نسيت كلمة المرور؟ قم بطلب تغييرها",
		"Change Password": "تغيير كلمة المرور",
		"Didn't forget the password?": "لا تحتاج تغيير كلمة المرور؟",
		"A confirmation code has been sent to your email": " تم إرسال كود التأكيد إلي بريدك الإلكتروني",
		"Invalid confirmation code": "كود التفعيل منتهي او غير صحيح",
		"Confirmation Code": "كود التأكيد",
		"New Password": "كلمة المرور الجديدة",
		"Password Confirmation": "إعادة كلمة المرور",
		"Your account have been successfully created": "تم تسجيل العضوية بنجاح",
		"Last step, Confirm your account by typing the code you received": "تبقي خطوة واحده، تفعيل الحساب عن طريق الكود المرسل",
		"Confirm": "تأكيد",
		"There are no data right now": "لا يوجد بيانات لعرضها حالياً",
		More: "المزيد",
		By: "بواسطة",
		Delete: "حذف",
		"Don't have account?": "لا تملك حساب؟",
		"Register Now": "سجل الأن",
		"Forget Password": "نسيت كلمة المرور",
		"Back": "العودة",
		"Email / Username": "إسم المستخدم / البريد الإلكتروني",
		"My Account": "حسابي",
		"Resend Code": "إعادة إرسال الكود",
		users: "العضويات",
		profile: "الملف الشخصي",
		setting: "الإعدادات",
		Notifications: "الإشعارات",
		Warning: "تنبيه",
		confirm: "تأكيد",
		All: "الكل",
		"Please fill out the required fields": "برجاء تعبئة الحقول المطلوبة",
		"Something went wrong, Please try again": "حدث خطأ، برجاء المحاولة مرة أخري",
		"Cancel": "إلغاء",
		"Are you sure?": "هل أنت متأكد؟",
		username: "إسم المستخدم",
		password: "كلمة المرور",
		Expires: "ينتهي",
		"Manage your logged-in devices": "إدارة جلسات الدخول",
		"Account Setting": "إعدادات الحساب",
		Days: "أيام",
		Hours: "ساعات",
		Minutes: "دقائق",
		Seconds: "ثواني",
		full_name: "الإسم الكامل",
		first_name: "الإسم الأول",
		last_name: "الإسم الأخير",
		mobile: "الجوال",
		role_ids: "الصلاحيات",
		email_activated_at: "تاريخ تفعيل الحساب",
		"General Setting": "الإعدادات العامة",
		"Welcome Back": "مرحبًا بعودتك",
		"Use Mobile Number": "إستخدم رقم الجوال",
		"Use Email": "إستخدم البريد الإلكتروني",
		phone: "الجوال",

		// validation
		"Validation error": "يجب تعبئة جميع الحقول ببيانات سليمة",
		validation_required: "هذا الحقل مطلوب ولا يمكن تركه فارغاً",
		validation_email: "يجب إدخال بريد إلكتروني صحيح",
		validation_password: "كلمة المرور يجب ان تتكون من 8 أرقام وأحرف كبيرة وصغيره",
		validation_mobile: "يجب إدخال رقم هاتف صحيح",
		validation_unique: "غير متاح",
		validation_invalid: "برجاء إدخال قيمة سليمة",
		validation_exists: "هذه القيمة موجودة سابقاً",
		validation_min_value: "القيمة اقل من المسموح به",
		validation_max_value: "القيمة أكبر من المسموح به",
		day: "يوم",
	},
	en: {
		dir: "ltr",
		"left": "left",
		"right": "right",
		permissions_cor: "System Permissions",
		full_name: "Full Name",
		first_name: "First Name",
		last_name: "Last Name",
		email_activated_at: "Account Activated At",

		// validation
		validation_required: "This field is required and can't be empty",
		validation_email: "Please, enter a valid email address",
		validation_password: "Password must be 8 lowercase, uppercase and numbers",
		validation_mobile: "Mobile number must be valid",
		validation_unique: "This value aleady exist",
		validation_invalid: "Please, enter a valid value",
		validation_exists: "This value aleady exist",
		validation_min_value: "The value less than the allowed value",
		validation_max_value: "The value greater than the allowed value",
	}
}

export default i18n;
